import { isContentLoaded, registerContent } from '../../shared/content.js';
import { registerArticles } from '../../shared/articles.js';
import type { Locale } from '../../shared/locales.js';

/**
 * Fetch the page prose and articles for one language.
 *
 * Written as an explicit switch rather than a computed `import(\`./content.${locale}.js\`)`
 * so the bundler can see all four targets statically and emit one chunk per language.
 * A visitor downloads the language they are reading and none of the others.
 */
export async function loadContent(locale: Locale): Promise<void> {
  if (isContentLoaded(locale)) return;

  switch (locale) {
    case 'fr': {
      const [content, articles] = await Promise.all([
        import('../../shared/content.fr.js'),
        import('../../shared/articles.fr.js'),
      ]);
      registerContent('fr', content.contentFr);
      registerArticles('fr', articles.articlesFr);
      return;
    }
    case 'es': {
      const [content, articles] = await Promise.all([
        import('../../shared/content.es.js'),
        import('../../shared/articles.es.js'),
      ]);
      registerContent('es', content.contentEs);
      registerArticles('es', articles.articlesEs);
      return;
    }
    case 'pt': {
      const [content, articles] = await Promise.all([
        import('../../shared/content.pt.js'),
        import('../../shared/articles.pt.js'),
      ]);
      registerContent('pt', content.contentPt);
      registerArticles('pt', articles.articlesPt);
      return;
    }
    case 'en': {
      const [content, articles] = await Promise.all([
        import('../../shared/content.en.js'),
        import('../../shared/articles.en.js'),
      ]);
      registerContent('en', content.contentEn);
      registerArticles('en', articles.articlesEn);
      return;
    }
  }
}
